import { Chip } from 'components/partials/insight-modal/shared/components';
import BlockHeader from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/components/block-header';

export interface ContextMetadata {
  insightType?: string;
  source?: string;
  sourceId?: string | number;
  relatedGoals?: string[];
  reportFilters?: Array<
    string | { column: string; values: string | string[] }
  >;
  [key: string]: unknown;
}

interface MonitoringContextProps {
  metadata: ContextMetadata | undefined;
}

const MonitoringContext = ({
  metadata,
}: MonitoringContextProps): React.JSX.Element => (
  <div className="flex gap-4 flex-col">
    <div>
      <BlockHeader title="Critical Element" />
      <Chip>{metadata?.source || 'N/A'}</Chip>
    </div>

    {metadata?.relatedGoals && !!metadata.relatedGoals.length && (
      <div>
        <BlockHeader title="Related goals" />
        <div className="flex flex-wrap gap-2">
          {metadata.relatedGoals.map((goal, index) => (
            <Chip key={index}>{goal}</Chip>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default MonitoringContext;
